<template>
  <div class="max-w-4xl mx-auto space-y-10">
    <!-- Header -->
    <div class="text-center space-y-3">
      <div class="flex justify-center">
        <svg class="w-10 h-10 text-nirvana-purple/40" viewBox="0 0 48 48" fill="currentColor">
          <path d="M24 4C24 4 16 12 16 20C16 24 19 27 24 28C29 27 32 24 32 20C32 12 24 4 24 4Z"/>
          <path d="M24 28C18 28 12 22 10 16C8 22 10 30 16 34C19 36 22 36 24 36C26 36 29 36 32 34C38 30 40 22 38 16C36 22 30 28 24 28Z" opacity="0.5"/>
        </svg>
      </div>
      <h1 class="text-3xl font-bold bg-gradient-to-r from-nirvana-cyan to-nirvana-lotus bg-clip-text text-transparent">
        ทีมแฮนด์เลอร์ผู้พัฒนา
      </h1>
      <div class="max-w-xs mx-auto ornate-divider"></div>
    </div>

    <!-- Team Grid -->
    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
      <div 
        v-for="member in team" 
        :key="member.name + member.role"
        class="crystal-card"
        v-motion-slide-visible-bottom
      >
        <div class="text-center space-y-4">
          <div class="relative mx-auto w-20 h-20">
            <div class="w-20 h-20 rounded-full flex items-center justify-center"
                 style="background: linear-gradient(135deg, rgba(123, 47, 242, 0.1), rgba(79, 209, 255, 0.1));">
              <component :is="member.icon" class="w-10 h-10 text-nirvana-cyan/70" />
            </div>
            <div class="absolute -inset-1 rounded-full border border-nirvana-purple/10"></div>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-nirvana-white/90">{{ member.name }}</h3>
            <p class="text-nirvana-lotus/50 text-sm">{{ member.role }}</p>
          </div>
          <div class="flex justify-center space-x-3">
            <a 
              v-for="social in member.socials"
              :key="social.url"
              :href="social.url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-nirvana-silver/25 hover:text-nirvana-cyan transition-colors duration-300"
            >
              <component :is="social.icon" class="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Special Thanks -->
    <div class="text-center space-y-3">
      <div class="ornate-divider max-w-xs mx-auto"></div>
      <h2 class="text-xl font-semibold text-nirvana-lotus/60">Special Thanks</h2>
      <p class="text-nirvana-silver/40 text-sm">
        น้องเนอร์สุดน่ารักและแฮนด์เลอร์ทุกท่าน! 💜
      </p>
    </div>
  </div>
</template>

<script setup>
import { Code2, Palette, Layout, Twitter, Github, Youtube } from 'lucide-vue-next'

const team = [
  {
    name: 'Kanosume',
    role: 'ผู้พัฒนาหลัก',
    icon: Code2,
    socials: [
      { icon: Twitter, url: 'https://twitter.com/prachameow' },
      { icon: Github, url: 'https://github.com/kanosume' },
      { icon: Youtube, url: 'https://youtube.com/@KanosumeUChannel' }
    ]
  },
  {
    name: 'Kanosume',
    role: 'UI/UX Designer',
    icon: Palette,
    socials: [
      { icon: Twitter, url: 'https://twitter.com/prachameow' },
      { icon: Github, url: 'https://github.com/kanosume' },
      { icon: Youtube, url: 'https://youtube.com/@KanosumeUChannel' }
    ]
  },
  {
    name: 'Kanosume',
    role: 'หัวหน้าโปรเจค',
    icon: Layout,
    socials: [
      { icon: Twitter, url: 'https://twitter.com/prachameow' },
      { icon: Github, url: 'https://github.com/kanosume' },
      { icon: Youtube, url: 'https://youtube.com/@KanosumeUChannel' }
    ]
  }
]
</script>
